<template>
  <header class="main-header">
    <div class="main-header__info">
      <h1 class="heading-page" :class="this.$store.state.isNavFixed ? 'text-dark' : 'text-white'">
        {{ (this.$route?.meta?.title ?? this.$route?.name) }}
      </h1>
      <nav aria-label="breadcrumb">
        <ol
          class="px-0 pt-1 pb-0 mb-0 bg-transparent breadcrumb"
          :class="`${this.$store.state.isNavFixed ? 'text-dark' : 'text-white'}`"
        >
          <li
            v-for="(crumb, index) in crumbs"
            :key="index"
            :class="{ 'active': index === crumbs.length - 1, 'text-sm breadcrumb-item': true, 'text-dark': this.$store.state.isNavFixed, 'text-white': !this.$store.state.isNavFixed }">
            <router-link v-if="index < crumbs.length - 1" :to="{ path: crumb.url }">{{ crumb?.title || '' }}</router-link>
            <span v-else>{{ crumb?.title || '' }}</span>
          </li>
        </ol>
      </nav>
    </div>
    <div class="main-header__account">
      <ThreeDotsMenu class="mx-4 w-4">
        <template #trigger>
          <div class="position-relative text-white" @mouseenter="getListNotif()">
            <svg class="text-white" style="width: 1.5rem; opacity: 1;" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 21"><path stroke="#ffffff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 3.464V1.099m0 2.365a5.34 5.34 0 0 1 5.133 5.368v1.8c0 2.386 1.867 2.982 1.867 4.175C15 15.4 15 16 14.462 16H1.538C1 16 1 15.4 1 14.807c0-1.193 1.867-1.789 1.867-4.175v-1.8A5.34 5.34 0 0 1 8 3.464M4.54 16a3.48 3.48 0 0 0 6.92 0z"></path></svg>
            <div v-if="unread_count > 0" class="rounded-circle h-2 w-2 bg-danger position-absolute top-0 end-0" style="padding: 5px"></div>
          </div>
        </template>
        <div class="" style="width: 400px;">
          <p class="text-lg font-weight-bolder">Notifikasi</p>
          
          <div class="sk-fading-circle" v-if="is_loading_notif">
            <div class="sk-circle1 sk-circle"></div>
            <div class="sk-circle2 sk-circle"></div>
            <div class="sk-circle3 sk-circle"></div>
            <div class="sk-circle4 sk-circle"></div>
            <div class="sk-circle5 sk-circle"></div>
            <div class="sk-circle6 sk-circle"></div>
            <div class="sk-circle7 sk-circle"></div>
            <div class="sk-circle8 sk-circle"></div>
            <div class="sk-circle9 sk-circle"></div>
            <div class="sk-circle10 sk-circle"></div>
            <div class="sk-circle11 sk-circle"></div>
            <div class="sk-circle12 sk-circle"></div>
          </div>

          <template v-else>
            <p v-if="list_notification.length === 0" class="text-center p-4">Data tidak ditemukan</p>
            <template v-for="(item, index) in list_notification" :key="index">
              <div
                class="p-2"
                :class="{
                  'cursor-pointer': item?.status === 'unread',
                  'border-bottom': (index + 1) < list_notification.length,
                }"
                :style="item?.status === 'unread' ? 'background: #ecf4ff;' : ''"
                @clic="item?.status === 'unread' ? setRead(index, item.id) : null"
              >
                <div class="d-flex justify-content-between">
                  <span class="font-weight-bold">{{ item?.title || '-' }}</span>
                  <span class="text-sm">{{ moment(item?.date +' '+ item?.time, "DD-MM-YYYY hh:mm:ss").fromNow() }}</span>
                </div>
                <span class="text-sm">
                  <template
                    v-for="(item_log, index_log) in item?.log"
                    :key="index_log"
                  >
                    <strong v-if="index_log % 2">{{ item_log }}&nbsp;</strong>
                    <span v-else>{{ item_log }}&nbsp;</span>
                  </template>
                </span>
              </div>
            </template>
          </template>

          <a href="/kye/notification" class="w-full text-center text-lg mt-4" style="color: #000000 !important; box-shadow: 0px -5px 12px 0px #888888;">
            Lihat Detail
          </a>
        </div>
      </ThreeDotsMenu>
      <div class="box-account">
        <figure class="box-account__avatar">
          <img
            :src="$store.state?.sessionUser?.employee?.photo || require('@/assets/img/avatar.png')"
            alt=""
            @error="(e) => {
              e.target.src = require('@/assets/img/avatar.png')
            }"
          >
        </figure>
        <div class="box-account__info">
          <p>{{ $store.state?.sessionUser?.employee?.name || $store.state?.sessionUser?.username || "-" }}</p>
          <span>NIP {{ $store.state?.sessionUser?.employee?.nip || "-" }}</span>
        </div>
        <div>
          <button class="box-account__cta" @click="logout()">
            <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><path d="M304 336v40a40 40 0 01-40 40H104a40 40 0 01-40-40V136a40 40 0 0140-40h152c22.09 0 48 17.91 48 40v40M368 336l80-80-80-80M176 256h256" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32"/></svg>
            <span class="">Logout</span>
          </button>
        </div>
      </div>
    </div>
  </header>
</template>

<style scoped>
a {
  color: white!important;
  opacity: 0.8;
}
</style>

<script>
import ThreeDotsMenu from "@/components/ThreeDotsMenu.vue";
import NotifikasiApi from "@/repository/api/NotifikasiApi";
import moment from 'moment';

export default {
  name: 'Breadcrumb',
  components: {
    ThreeDotsMenu,
  },
  watch: {
    $route(to) {
      if (to?.matched) {
        this.getBreadcrumbs(to.matched)
      }
    }
  },
  data() {
    return {
      crumbs: [],
      unread_count: 0,
      list_notification: [],
      is_loading_notif: false,
    }
  },
  methods: {
    moment,
    getBreadcrumbs(matched) {
      this.crumbs = []

      try {
        let segments = JSON.parse(JSON.stringify(matched))

        segments.map((item) => {
          if (this.crumbs.indexOf({
            title: item?.meta?.title ?? "",
            url: item.path
          }) == -1) {
            this.crumbs.push({
              title: item?.meta?.title ?? "",
              url: item.path
            })
          }
        })
      } catch (e) {
        return console.error(e); // error in the above string (in this case, yes)!
      }

      this.crumbs = this.crumbs.reduce((acc, current) => {
        const x = acc.find(item => item.title === current.title && item.url === current.url);
        if (!x) {
          return acc.concat([current]);
        } else {
          return acc;
        }
      }, []);
    },
    getUnread() {
      NotifikasiApi.getUnread()
        .then((res) => {
          this.unread_count = res?.data?.data?.unread > 0 ? res?.data?.data?.unread : 0
        })
        .catch((err) => {
          console.log(err)
          this.unread_count = 0
        })
    },
    getListNotif() {
      this.is_loading_notif = true
      NotifikasiApi.getList()
        .then((res) => {
          this.list_notification = []
          if (res?.data?.data?.items?.length > 0) {
            this.list_notification = res?.data?.data?.items
          }
        })
        .catch((err) => {
          console.log(err)
        })
        .finally(() => {
          this.is_loading_notif = false
        })
    },
    async setRead(index, id) {
      await NotifikasiApi.setRead(id)
        .then(() => {
          this.getListNotif();
        })
    },
  },
  mounted() {
    this.getUnread();

    // websocket
    try {
      const socket = new WebSocket(process.env.VUE_APP_WEBSOCKET_URL);

      socket.onerror = (error) => {
        console.log("WebSocket error:", error)
      }
      
      socket.onmessage = (event) => {
        if (event?.data !== undefined) {
          const notif_data = JSON.parse(event.data);
          this.getUnread();
          setTimeout(() => {
            this.$swal({
              icon: 'info',
              title: notif_data?.title || '-',
              text: notif_data?.body || '-',
              confirmButtonText: 'Tutup',
            })
          }, 5000);
        }
      }
    } catch (err) {
      console.log(err)
      console.log('failed connect to websocket')
    }
  }
}
</script>

<style scoped>

.main-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.main-header__info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex-grow: 1;
}
.main-header__account {
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}


.heading-page {
  font-size: 22px;
  margin: 0px;
  padding: 0px;
}
.breadcrumb {
  background-color: #f5f5f5;
}

.breadcrumb ul {
  display: flex;
  align-items: center;
}
.breadcrumb .breadcrumb-item {
  padding-left: 0;
  padding-right: 32px;
  position: relative;
}

.breadcrumb .breadcrumb-item a:hover {
  color: #ffffff !important;
  text-decoration: underline;
  opacity: 1;
}

.breadcrumb li+li:before {
  content: '';
  position: absolute;
  width: 20px;
  height: 20px;
  left: -24px;
  top: 1px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: url('../assets/img/icons/chevron-right.svg')no-repeat center center;
  background-size: 16px;
  opacity: 0.6;
}

.breadcrumb li.is-active {
  font-weight: bold;
  color: #3273dc;
}

/* notif loading */
.sk-fading-circle {
  margin: auto;
  width: 40px;
  height: 40px;
  position: relative; }

.sk-fading-circle .sk-circle {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0; }

.sk-fading-circle .sk-circle:before {
  content: '';
  display: block;
  margin: 0 auto;
  width: 15%;
  height: 15%;
  border: 2px solid #585858;
  background-color: #FFFFFF;
  border-radius: 100%;
  -webkit-animation: sk-circleFadeDelay 1.2s infinite ease-in-out both;
    -webkit-animation-animation: sk-circleFadeDelay 1.2s infinite ease-in-out both; }

.sk-fading-circle .sk-circle2 {
  -webkit-transform: rotate(30deg);
    -webkit-transform--ms-transform: rotate(30deg);
      -webkit-transform--ms-transform-transform: rotate(30deg); }

.sk-fading-circle .sk-circle3 {
  -webkit-transform: rotate(60deg);
    -webkit-transform--ms-transform: rotate(60deg);
      -webkit-transform--ms-transform-transform: rotate(60deg); }

.sk-fading-circle .sk-circle4 {
  -webkit-transform: rotate(90deg);
    -webkit-transform--ms-transform: rotate(90deg);
      -webkit-transform--ms-transform-transform: rotate(90deg); }

.sk-fading-circle .sk-circle5 {
  -webkit-transform: rotate(120deg);
    -webkit-transform--ms-transform: rotate(120deg);
      -webkit-transform--ms-transform-transform: rotate(120deg); }

.sk-fading-circle .sk-circle6 {
  -webkit-transform: rotate(150deg);
    -webkit-transform--ms-transform: rotate(150deg);
      -webkit-transform--ms-transform-transform: rotate(150deg); }

.sk-fading-circle .sk-circle7 {
  -webkit-transform: rotate(180deg);
    -webkit-transform--ms-transform: rotate(180deg);
      -webkit-transform--ms-transform-transform: rotate(180deg); }

.sk-fading-circle .sk-circle8 {
  -webkit-transform: rotate(210deg);
    -webkit-transform--ms-transform: rotate(210deg);
      -webkit-transform--ms-transform-transform: rotate(210deg); }

.sk-fading-circle .sk-circle9 {
  -webkit-transform: rotate(240deg);
    -webkit-transform--ms-transform: rotate(240deg);
      -webkit-transform--ms-transform-transform: rotate(240deg); }

.sk-fading-circle .sk-circle10 {
  -webkit-transform: rotate(270deg);
    -webkit-transform--ms-transform: rotate(270deg);
      -webkit-transform--ms-transform-transform: rotate(270deg); }

.sk-fading-circle .sk-circle11 {
  -webkit-transform: rotate(300deg);
    -webkit-transform--ms-transform: rotate(300deg);
      -webkit-transform--ms-transform-transform: rotate(300deg); }

.sk-fading-circle .sk-circle12 {
  -webkit-transform: rotate(330deg);
    -webkit-transform--ms-transform: rotate(330deg);
      -webkit-transform--ms-transform-transform: rotate(330deg); }

.sk-fading-circle .sk-circle2:before {
  -webkit-animation-delay: -1.1s;
    -webkit-animation-delay-animation-delay: -1.1s; }

.sk-fading-circle .sk-circle3:before {
  -webkit-animation-delay: -1s;
    -webkit-animation-delay-animation-delay: -1s; }

.sk-fading-circle .sk-circle4:before {
  -webkit-animation-delay: -0.9s;
    -webkit-animation-delay-animation-delay: -0.9s; }

.sk-fading-circle .sk-circle5:before {
  -webkit-animation-delay: -0.8s;
    -webkit-animation-delay-animation-delay: -0.8s; }

.sk-fading-circle .sk-circle6:before {
  -webkit-animation-delay: -0.7s;
    -webkit-animation-delay-animation-delay: -0.7s; }

.sk-fading-circle .sk-circle7:before {
  -webkit-animation-delay: -0.6s;
    -webkit-animation-delay-animation-delay: -0.6s; }

.sk-fading-circle .sk-circle8:before {
  -webkit-animation-delay: -0.5s;
    -webkit-animation-delay-animation-delay: -0.5s; }

.sk-fading-circle .sk-circle9:before {
  -webkit-animation-delay: -0.4s;
    -webkit-animation-delay-animation-delay: -0.4s; }

.sk-fading-circle .sk-circle10:before {
  -webkit-animation-delay: -0.3s;
    -webkit-animation-delay-animation-delay: -0.3s; }

.sk-fading-circle .sk-circle11:before {
  -webkit-animation-delay: -0.2s;
    -webkit-animation-delay-animation-delay: -0.2s; }

.sk-fading-circle .sk-circle12:before {
  -webkit-animation-delay: -0.1s;
    -webkit-animation-delay-animation-delay: -0.1s; }

@-webkit-keyframes sk-circleFadeDelay {
  0%, 39%, 100% {
    opacity: 0; }
  40% {
    opacity: 1; } }

@keyframes sk-circleFadeDelay {
  0%, 39%, 100% {
    opacity: 0; }
  40% {
    opacity: 1; } }

</style>
